import Page from 'classes/Page'

export default class Default extends Page {
    constructor() {
        super()
    }

    init() {
        super.init()
    }

    onResize() {
        super.onResize()
    }

    onScroll() {
        super.onScroll()
    }
}